import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAdmin } from '../../context/AdminContext';
import { useAuth } from '../../context/AuthContext';
import LoadingSpinner from './LoadingSpinner';

const ProtectedRoute = ({ children, adminRoute = false }) => {
  const location = useLocation();

  // Always call hooks at the top level
  const { admin, loading: adminLoading, isAdminAuthenticated } = useAdmin();
  const { user, loading: userLoading, isAuthenticated } = useAuth();

  // Decide which context to use
  if (adminRoute) {
    if (adminLoading) {
      return (
        <div className="loading-container">
          <LoadingSpinner />
          <p>Verifying admin access...</p>
        </div>
      );
    }

    if (!isAdminAuthenticated || !admin) {
      return <Navigate to="/admin/login" state={{ from: location }} replace />;
    }

    return children;
  } else {
    // User routes logic
    if (userLoading || adminLoading) {
      return (
        <div className="loading-container">
          <LoadingSpinner />
          <p>Verifying authentication...</p>
        </div>
      );
    }

    // Allow authenticated admins to pass through user routes
    if (isAdminAuthenticated && admin) {
      return children;
    }

    if (!isAuthenticated || !user) {
      return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (!user.isVerified) {
      return <Navigate to="/verify-otp" state={{ userId: user.id }} replace />;
    }

    if (user.status !== 'active') {
      return (
        <div className="account-suspended">
          <div className="suspension-notice">
            <h2>Account Suspended</h2>
            <p>Your account has been suspended. Please contact support for assistance.</p>
            <button onClick={() => (window.location.href = '/login')}>
              Back to Login
            </button>
          </div>
        </div>
      );
    }

    // WhatsApp Connection Gate
    const isConnectionRoute = location.pathname === '/connect-whatsapp' ||
      location.pathname === '/whatsapp-callback';

    if (!user.whatsappConnected && !isConnectionRoute) {
      return <Navigate to="/connect-whatsapp" replace />;
    }

    return children;
  }
};

export default ProtectedRoute;
